import script from "./InputDate.vue?vue&type=script&setup=true&lang=js"
export * from "./InputDate.vue?vue&type=script&setup=true&lang=js"

import "./InputDate.vue?vue&type=style&index=0&id=f5113034&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f5113034"]])

export default __exports__